import React, { useMemo } from "react";

import CustomSection from "../custom-general/custom-section";
import PDFTablePage from "../../themed/pdf/pdfTablePage";

import { GREChecklistItem } from "./gre/greCheckList";
import { Column } from "../../../utils/models";

interface Props {
    items: GREChecklistItem[];
}

const GREChecklistReport: React.FC<Props> = ({ items }) => {
    const checklist = useMemo(() => {
        return items.map((item, index) => ({ ...item, id: index + 1 }));
    }, [items]);

    return ( 
        <CustomSection sectionTitle="Anomaly Checklist">
            <div className="p-1">
                <PDFTablePage data={checklist} columns={COLUMNS} />
            </div>
        </CustomSection>
    );
};

const COLUMNS: Column[] = [
    {
        path: 'id',
        label: 'Item'
    },
    {
        path: 'label',
        label: 'Line Number',
        style: () => ({ textAlign: 'left' }),
        headerStyle: { backgroundColor: '#a02c93', textAlign: 'left', color: '#ffffff' }
    },
    {
        path: 'assessment',
        label: 'Assessment',
    },
    {
        path: 'comment',
        label: 'Comment',
    },
];
 
export default GREChecklistReport;